export default function safeSetter<T extends Record<string, any>>(
  obj: T,
  path: string,
  value: any
): void {
  let current: any = obj;

  const keys = path.split(".");

  for (let i = 0; i < keys.length - 1; i += 1) {
    const key = keys[i];
    if (["__proto__", "constructor", "prototype"].includes(key)) {
      throw new Error(`Unsafe key in path: ${key}`);
    }

    if (typeof current[key] !== "object" || current[key] === null) {
      current[key] = {};
    }
    current = current[key];
  }

  const lastKey = keys[keys.length - 1];
  if (["__proto__", "constructor", "prototype"].includes(lastKey)) {
    throw new Error(`Unsafe key in path: ${lastKey}`);
  }

  current[lastKey] = value;
}
